import React, { useState } from 'react';
import { AiOutlineArrowUp } from 'react-icons/ai';
import { FaPaperPlane } from 'react-icons/fa';
import logo from '../../assets/img/f_logo.webp';
import anpcSal from '../../assets/img/anpc-sal.webp';
import WidgetAbout from './WidgetAbout';
import WidgetGetinTouch from './WidgetGetinTouch';
import WidgetGetinTouchData from './WidgetGetinTouchData';
import WidgetNews from './WidgetNews';
import WidgetNewsData from './WidgetNewsData';

function Footer1() {
    // STATES
    const [email, setEmail] = useState('');

    // HANDLER
    const onchangeHandler = (e) => {
        setEmail(e.target.value);
    };
    const onSubmitHandler = (e) => {
        e.preventDefault();
    };
    return (
        <footer className="footer-1 footer-wrap">
            <div className="footer-widgets dark-bg">
                <div className="container">
                    <div className="row">
                        {/* ABOUT WIDGET */}
                        <WidgetAbout
                            text="Work Express este o companie dinamică și inovatoare, fondată în 2017, dedicată furnizării soluțiilor eficiente și moderne pentru nevoile clienților noștri. Cu o echipă pasionată și orientată spre excelență, ne străduim să oferim rezultate de înaltă calitate."
                            fbLink="https://facebook.com"
                            twitterLink="https://twitter.com"
                            instaLink="https://instagram.com"
                            youtubeLink="https://youtube.com"
                        />

                        {/* SERVICII WIDGET */}
                        <div className="col-md-6 col-xl-3 col-12">
                            <div className="single-footer-wid">
                                <div className="wid-title">
                                    <h4>Serviciile Noastre</h4>
                                </div>
                                <ul style={{listStyle: 'none', padding: 0}}>
                                    <li style={{marginBottom: '10px'}}><a href="/servicii" style={{color: '#fff'}}>Izolații și Hidroizolații</a></li>
                                    <li style={{marginBottom: '10px'}}><a href="/servicii" style={{color: '#fff'}}>Instalații Electrice</a></li>
                                    <li style={{marginBottom: '10px'}}><a href="/servicii" style={{color: '#fff'}}>Vopsitorie și Tapet</a></li>
                                    <li style={{marginBottom: '10px'}}><a href="/servicii" style={{color: '#fff'}}>Gips-Carton</a></li>
                                    <li style={{marginBottom: '10px'}}><a href="/servicii" style={{color: '#fff'}}>Tencuieli și Șape</a></li>
                                </ul>
                            </div>
                        </div>

                        {/* LINKURI UTILE WIDGET */}
                        <div className="col-md-6 col-xl-3 col-12">
                            <div className="single-footer-wid">
                                <div className="wid-title">
                                    <h4>Linkuri Utile</h4>
                                </div>
                                <ul style={{listStyle: 'none', padding: 0}}>
                                    <li style={{marginBottom: '10px'}}><a href="/" style={{color: '#fff'}}>Acasă</a></li>
                                    <li style={{marginBottom: '10px'}}><a href="/despre-noi" style={{color: '#fff'}}>Despre Noi</a></li>
                                    <li style={{marginBottom: '10px'}}><a href="/servicii" style={{color: '#fff'}}>Servicii</a></li>
                                    <li style={{marginBottom: '10px'}}><a href="/intrebari-frecvente" style={{color: '#fff'}}>Întrebări Frecvente</a></li>
                                    <li style={{marginBottom: '10px'}}><a href="/contact" style={{color: '#fff'}}>Contact</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-6 col-xl-3 col-12">
                            <div className="single-footer-wid ml-15 site_info_widget">
                                <div className="wid-title">
                                    <h4>Contact</h4>
                                </div>
                                <div className="contact-us" />
                                {WidgetGetinTouchData.map((data) => (
                                    <WidgetGetinTouch
                                        key={data.id}
                                        icon={data.icon}
                                        heading={data.heading}
                                        text={data.text}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ANPC Section */}
            <div className="anpc-section" style={{
                backgroundColor: '#1a1a1a',
                padding: '20px 0',
                borderTop: '1px solid #333'
            }}>
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-6 col-md-8 col-12 text-center">
                            <a
                                href="https://anpc.ro/ce-este-sal/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{display: 'inline-block', marginBottom: '10px'}}
                            >
                                <img
                                    src={anpcSal}
                                    alt="ANPC SAL - Soluționarea Alternativă a Litigiilor"
                                    style={{
                                        maxWidth: '200px',
                                        height: 'auto',
                                        opacity: '0.85',
                                        transition: 'opacity 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.opacity = '1'}
                                    onMouseOut={(e) => e.currentTarget.style.opacity = '0.85'}
                                />
                            </a>
                            <p style={{
                                color: '#999',
                                fontSize: '12px',
                                marginTop: '10px',
                                lineHeight: '1.6'
                            }}>
                                <strong style={{color: '#fff'}}>Notă:</strong> Platforma SOL (Soluționarea Online a Litigiilor) a fost întreruptă de către Comisia Europeană la data de 20 iulie 2025. Pentru soluționarea disputelor, vă rugăm să utilizați platforma SAL (Soluționarea Alternativă a Litigiilor).
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer bottom */}
            <div className="footer-bottom">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-12">
                            <div className="copyright-info">
                                <p>
                                    &copy; Copyright By <a href="/">Work Express</a> - 2025
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 text-center">
                            <div className="footer-logo">
                                <a href="#top">
                                    <img src={logo} alt="Work Express" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-4 d-none d-lg-block col-12">
                            <div className="scroll-up-btn text-md-right justify-content-end">
                                <a href="#top">
                                    <AiOutlineArrowUp />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer1;
